import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const TARIFFTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.TariffType.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.TariffType.Code')
    .required()
    .minLength(2)
    .maxLength(20)
    .build(),
  FieldBuilder
    .text('updateTariff', 'Entity.TariffType.UpdateTariff')
    .required()
    .build(),
];

export const TARIFFTYPE_CONFIG = {
  entityName: 'TariffType',
  localizationKey: 'Controlling::Entity.TariffType',
  fields: TARIFFTYPE_FIELDS,
  permission: 'ControllingLiquidations.TariffTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
